import { fade, makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import InputBase from '@material-ui/core/InputBase';
import TextField from '@material-ui/core/TextField';
import Badge from '@material-ui/core/Badge';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import CreateIcon from '@material-ui/icons/Create';
import SearchIcon from '@material-ui/icons/Search';
import AccountCircle from '@material-ui/icons/AccountCircle';
import MailIcon from '@material-ui/icons/Mail';
import NotificationsIcon from '@material-ui/icons/Notifications';
import MoreIcon from '@material-ui/icons/MoreVert';
import {authConfig} from '../auth/config';
import React, { useState} from 'react';
import MenuUser from '../componentes/menuUser';
import Menurecado from '../componentes/menurecado';
import {withRouter,Redirect, Link,useHistory} from 'react-router-dom';
import PowerSettingsNewIcon from '@material-ui/icons/PowerSettingsNew';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Cardconsulta from '../pages/cardpesquisa';
import firebase from "firebase/app";
import 'firebase/firestore';

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexGrow: 0,
    flexDirection: 'column',
    alignItems: 'center',
  },
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'block',
    },
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(3),
      width: 'auto',
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputRoot: {
    color: 'inherit',
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '20ch',
    },
  },
  sectionDesktop: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
  },
  sectionMobile: {
    display: 'flex',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
}));

export const PrimarySearchAppBar = withRouter(({history}) => {

 
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);
  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
  
  

 const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };
  async function handleLogout() {
    
    try{
      await authConfig
            .auth().signOut();
          
      history.push('/'); 
    }catch(error){
      console.log(error);
    }
    
  };
  
  

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const [opendialogpesquisa, setaopendialogpesquisa] = React.useState(false);
 
 const handleClickopendialogpesquisa= () => {
  setaopendialogpesquisa(true);
 };

 const handleCloseddialogpesquisa = () => {
  setaopendialogpesquisa(false);
 };

 const [state, setState] = useState([]);
 async function  handlepesquisar(valor){
  console.log(valor);

  var db = firebase.firestore();
      var query = db.collection("agenda").where("nsolicitacao", "==", valor).get()
      .then(function(querySnapshot) {
        if (!querySnapshot.empty) {
        querySnapshot.forEach(function(doc) {
          
            var listausers=[];
            listausers.push({id: doc.id, datahoraretorno: doc.data().datahoraretorno,observacao:doc.data().observacao, anexo:doc.data().anexo, status:doc.data().status,
             datahorasaida:doc.data().datahorasaida, dsolicitacao: doc.data().dsolicitacao,campisolicitante:doc.data().campisolicitante,valorkmrodado:doc.data().valorkmrodado,
             listapassageiros: doc.data().listapassageiros, depsolicitacao: doc.data().depsolicitacao, nomesolicitante: doc.data().nomesolicitante, idsolicitante:doc.data().idsolicitante,
             npassageiro: doc.data().npassageiro, nsolicitacao: doc.data().nsolicitacao,objetivo: doc.data().objetivo,totalkm: doc.data().kilometragem, statususer:doc.data().statususer,fila:doc.data().fila,
             siapesolicitente: doc.data().siapesolicitente,telefonesolicitante: doc.data().telefonesolicitante,listaparadasida: doc.data().listaparadasida,listaparadasvolta: doc.data().listaparadasvolta,
             localdestino: doc.data().localdestino,localsaida: doc.data().localsaida, tipodeslocamento:doc.data().tipodeslocamento, nomerespdespesas:doc.data().nomerespdespesas,
             fonerespdespesas:doc.data().fonerespdespesas, respdespesas:doc.data().respdespesas, autorizacoes:doc.data().autorizacoes,veiculo: doc.data().veiculo, motorista: doc.data().motorista,
             
             
            });
            console.log("AAAAAAAAAAAAAAAAAAAAAAAaaa",listausers);
            setState (listausers);
            handleClickopendialogpesquisa();

         /* } else {
            alert("Não encontramos nehuma solicitação com o numero informado");
          }*/
      
        }) 
      }else{
        alert("Não encontramos Resultados para sua pesquisa");
    }
  })
   .catch(error => {
       console.log(error);
   });
 
 
}


function NomeAvatar(){
  var user = authConfig.auth().currentUser;
 
  return(
    user.displayName
  )
};


const [openeditanome, setaopeneditanome] = React.useState(false);
const [novonome, setanovonome] = React.useState('');

const handleopeneditanome=()=>{
  setaopeneditanome(true)
}
const handlecloseeditanome=()=>{
  setaopeneditanome(false)
}

function salvaeditanome(){
  var user = authConfig.auth().currentUser;
 
  //const user = firebase.auth().currentUser;

user.updateProfile({
  displayName: novonome,
 // photoURL: "https://example.com/jane-q-user/profile.jpg"
}).then(() => {
  handlecloseeditanome();
  alert("Nome de exibição alterado");
  // Update successful
  // ...
}).catch((error) => {
  // An error occurred
  // ...
  handlecloseeditanome();
  alert("Nome de exibição alterado");

});  
};




  const menuId = 'primary-search-account-menu';
  

  const mobileMenuId = 'primary-search-account-menu-mobile';
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      
      <MenuItem>
        <IconButton aria-label="Notificações" color="inherit">
          <Badge color="secondary" label={"Notificações"}>
            <Menurecado />
            
          </Badge>
        </IconButton>
       </MenuItem>

      <MenuItem onClick={handleLogout}>
        <IconButton
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"
        >
          <PowerSettingsNewIcon />
        </IconButton>
        <p>Sair</p>
      </MenuItem>
    </Menu>
  );

  return (
    <div className={classes.grow}>

<Dialog open={openeditanome} variant="outlined" onClose={handleopeneditanome} aria-labelledby="form-dialog-title" >
        <DialogTitle id="form-dialog-edita">Digite o novo nome de exibição</DialogTitle>
        <DialogContent>
          <DialogContentText>
         
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            onInput={ e=>setanovonome(e.target.value)}
            name="nome"
            label="Nome de Exibição"
            type="text"
            id="novonome"
            
          />
          

         </DialogContentText>
            
        </DialogContent>
        <DialogActions>
        <Button variant="contained" onClick={salvaeditanome} color="primary" >
            Salvar
          </Button>
         <Button variant="contained" onClick={handlecloseeditanome} color="primary" >
         Cancelar
          </Button>
          </DialogActions>
      </Dialog>

      <Dialog  open={opendialogpesquisa} onClose={handleCloseddialogpesquisa} aria-labelledby="form-dialog-title" >
        <DialogTitle id="form-dialog-naodep">Resultado da Pesquisa</DialogTitle>
        <DialogContent>
          <DialogContentText>
        
         
           <Cardconsulta props={state} />
                
         
          
         </DialogContentText>
            
        </DialogContent>
        <DialogActions>
            
           
          <Button variant="contained" onClick={handleCloseddialogpesquisa} color="primary" >
            OK
          </Button>
          </DialogActions>
      </Dialog>
      <AppBar position="static">
        <Toolbar>
         <MenuUser/>
          <Typography className={classes.title} variant="h6" noWrap>
            Frota UFSM
          </Typography>
          <div className={classes.search}>
            <div className={classes.searchIcon}>
              <SearchIcon />
            </div>
            <InputBase
              placeholder="Nº da Solicitação…"
              
              classes={{
                root: classes.inputRoot,
                input: classes.inputInput,
              }}
              inputProps={{ 'aria-label': 'search' }}
              //value={pesquisa}
              //onLoad={e=>handlepesquisar()}
              onKeyPress={(e) => e.key === 'Enter' && handlepesquisar(e.target.value)}
            />
          </div>
          <div className={classes.grow} />
          <div className={classes.sectionDesktop}>
          <Typography className={classes.title} variant="h5" noWrap>
          < NomeAvatar/>
          </Typography>
          <IconButton id="bteditar" aria-label="Editar" onClick={handleopeneditanome}>
               <CreateIcon />
             </IconButton>

          <Menurecado/>
          
        {  //<Menurecado/>
        }
            <IconButton
              edge="end"
              aria-label="account of current user"
              aria-controls={menuId}
              aria-haspopup="true"
              onClick={handleLogout}
              color="inherit"
            >
              <PowerSettingsNewIcon />
            </IconButton>
          </div>
          <div className={classes.sectionMobile}>
            <IconButton
              aria-label="show more"
              aria-controls={mobileMenuId}
              aria-haspopup="true"
              onClick={handleMobileMenuOpen}
              color="inherit"
            >
              <MoreIcon />
            </IconButton>
          </div>
        </Toolbar>
      </AppBar>
      {renderMobileMenu}
      
      
    </div>
  
    
  );

  
})
export default PrimarySearchAppBar;
